import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Stundenlange Vorbereitung — jede Woche aufs Neue.', 'Material aus vielen Quellen mühsam zusammensuchen.', 'Unsicherheit, ob alle Themen abgedeckt sind.', 'Kaum Zeit für kreative Aktivitäten.', 'Wenig Struktur über die Klassenstufen hinweg.'];
const after = ['Fertige Stunden, sofort einsetzbar.', 'Alles an einem Ort — 10 aufeinander aufbauende Bände.', 'Klarer Lehrplan von Klasse 1 bis 9.', 'Praktische Aktivitäten auf jeder Seite.', 'Lernkontrollen und Lösungen inklusive.'];
const highlights = [['600', 'Seiten'], ['6 Einheiten', 'pro Band'], ['100%', 'druckbar & digital']];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-166" data-mp="2968fiizn9rfl">
      <Reveal className="mx-auto max-w-5xl" data-id="element-167" data-mp="248glnjffvv8r">
        <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="207d48shqtr5f">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-169" data-mp="207wo4eqyepm3">
            Ein besserer Weg, Musik zu unterrichten
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-brand-navy md:text-[2.75rem]" data-id="element-170" data-mp="k2ubtmbd496f">
            Vom überforderten Musiklehrer zum{' '}
            <span className="font-script italic text-brand-orange" data-id="element-171" data-mp="abpwumlosobl">
              sicheren Musik-Guide.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-172" data-mp="y2vdh3zgbkmy">
            Jeder Band nimmt dir die Vorbereitung ab — mit fertigen Stunden,
            praktischen Aktivitäten und Lernkontrollen. So kannst du dich auf
            das Wesentliche konzentrieren: das Unterrichten und die Freude an
            der Musik.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-line overflow-hidden rounded-2xl border border-brand-line bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-173" data-mp="39q1pgwwdctte">
          {highlights.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-174" data-mp="1kbtqr07fq1fz">
              <strong className="block font-display text-2xl font-extrabold leading-none text-brand-orange" data-id="element-175" data-mp="1fc7bymbykd52">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.1em] text-brand-gray" data-id="element-176" data-mp="15lcojemz77i1">
                {label}
              </span>
            </div>)}
        </div>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-177" data-mp="wkoc2od8df79">
          <Comparison title="Vorher" items={before} positive={false} data-id="element-178" data-mp="witr5a1yln36" />
          <Comparison title="Mit Musik Startklar" items={after} positive data-id="element-179" data-mp="rkii31jhngm0" />
        </div>
        <p className="mt-8 text-center text-sm font-semibold text-brand-gray" data-id="element-180" data-mp="mmqm9wfq3acj">
          Ein kompletter Lehrplan, der deine Vorbereitung auf wenige Minuten
          verkürzt.
        </p>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className="rounded-3xl border border-brand-line bg-brand-alt p-7 shadow-sm md:p-9" data-id="element-181" data-mp="2tic54nhweaky">
      <h3 className="mb-6 font-display text-xl font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-182" data-mp="2y9u97kf7wra5">
        {title}
      </h3>
      <ul className="space-y-3" data-id="element-183" data-mp="337m0qdbyabdt">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-184" data-mp="26io2um8wlxcf">
            <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-green/10 text-brand-green' : 'bg-brand-red/10 text-brand-red'}`} data-id="element-185" data-mp="26k7lukly2mhw">
              <Icon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-186" data-mp="2flffuqhfh166" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-187" data-mp="2kft6ygp24m51">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}